import { PrimeReactPTOptions } from "primereact/api";
import { classNames } from "primereact/utils";
import { AutoCompletePassThroughMethodOptions } from "primereact/autocomplete";

import { focusHoverField, invalidField, placeholder } from "./common";

export const autocomplete: PrimeReactPTOptions["autocomplete"] = {
  root: {
    className: classNames("relative inline-flex"),
  },
  container: ({ props }: AutoCompletePassThroughMethodOptions) => {
    return {
      className: classNames(
        "m-0 list-none cursor-text overflow-hidden flex items-center flex-wrap w-full",
        "h-[40px] p-3",
        "px-3 py-1 gap-1",
        "text-urbe-gray text-sm border border-urbe-border bg-white",
        placeholder,
        "transition duration-200 ease-in-out appearance-none rounded",
        focusHoverField,
        {
          "bg-urbe-grayLight select-none pointer-events-none cursor-default": props.disabled,
          [invalidField]: props.invalid,
        },
      ),
    };
  },
  inputToken: {
    className: classNames("py-0.375rem px-0", "flex-1 inline-flex"),
  },
  loadingIcon: ["right-[0.6rem] w-[16px] h-[16px] text-urbe-border bg-white z-10"],
  tokenLabel: ["pr-1"],
  token: {
    className: classNames(
      "px-2 mr-1 bg-[#E8DEF6] text-[#6E4299] rounded-full",
      "cursor-default inline-flex items-center",
    ),
  },
  dropdownButton: {
    root: ["rounded-tl-none rounded-bl-none"],
  },
  panel: {
    className: classNames(
      "bg-white text-gray-700 border-0 rounded-md shadow-lg text-sm",
      "max-h-[200px] overflow-auto",
      "dark:bg-gray-900 dark:text-white/80",
    ),
  },
  list: ["py-3 list-none m-0"],
  item: ({ context }: AutoCompletePassThroughMethodOptions) => {
    return {
      className: classNames(
        "cursor-pointer font-normal overflow-hidden relative whitespace-nowrap",
        "m-0 px-3 py-2 border-0 text-sm transition-shadow duration-200 rounded-none",
        {
          "text-urbe-gray hover:text-gray-700 hover:bg-gray-200 dark:text-white/80 dark:hover:bg-gray-800":
            !context.selected,
          "bg-urbe-primaryLight ": context.selected,
        },
      ),
    };
  },
  itemGroup: {
    className: classNames(
      "m-0 p-3 text-gray-800 bg-white font-bold",
      "dark:bg-gray-900 dark:text-white/80",
      "cursor-auto",
    ),
  },
};
